import * as React from 'react';

import { connect, Dispatch } from 'react-redux';

import { IAddOnsAppState } from '../../redux-state';
import { IAddOnsAppText } from '../../custom/classes/add-ons-text';
import { IAddOnProduction } from '../../custom/classes/production';
import ListPerformanceView from 'list-addon-performance.view';
import { IBaseZone, IPerformanceInfo, IReserveRequest } from '../../../add-ons/classes/add-ons';
import { getPerformancePricing } from '../../../add-ons/redux-state/actions/add-ons-api.actions';
import { addPerformanceToRequest, removePerformanceFromRequest, updatePriceTypeToRequest, updateZoneToRequest, updateTotal, displayLoading } from '../../../add-ons/redux-state/actions/add-ons.actions';


interface ListPerformanceViewState {
    performanceChecked: boolean;
    disablePriceTypeQuantity: boolean;
    priceTypeQuantity: Map<number, number>;
    quantityValue: boolean;
    zoneId: number;
    singlePerf: boolean;
}
interface ListPerformanceViewProps {
    priceTypeQuantityUpdate: (performanceNumber: number, priceTypeId: number, quantity: number) => void;
    updatePerformance: (event: React.ChangeEvent<HTMLInputElement>)=> void;
    updateZone: (performanceId: number, zoneId: number)=> void;
}
interface IPerformanceExternalProps {
    performance: IPerformanceInfo;
    performancesCount: number;
    hideDate: boolean;
    panelOpen: boolean;
}

interface StateToProps {
    performanceDetail: IPerformanceInfo;
    reserveFailed: boolean;
    resetSelectedPerformance: boolean;
    containsreserveItems: boolean;
    reservedPerformances: IReserveRequest[];
    text: IAddOnsAppText;
    displayLoading: boolean;
}

interface DispatchToProps {
    getPerformancePricingInfo: (id: number) => void;
    addPerformanceToRequest: (id: number) => void;
    removePerformanceFromRequest: (id: number) => void;
    updatePriceTypeToRequest: (performanceId: number, priceTypeId: number, quantity: number) => void;
    updateZoneToRequest: (performanceId: number, zoneId: number) => void;
    updateTotal: (performanceId: number, total: number) => void;
    displayLoading: (enable: boolean) => void;
}

export type ListPerformancesProps = IPerformanceExternalProps & StateToProps & DispatchToProps;
export type ListPerformancesPropsView = ListPerformancesProps & ListPerformanceViewState & ListPerformanceViewProps;
export class ListPerformanceBase extends React.Component<ListPerformancesProps, ListPerformanceViewState> {

    constructor(props: ListPerformancesProps) {
        super(props);


        this.state = {
            performanceChecked: false,
            priceTypeQuantity: new Map<number, number>(),
            quantityValue: false,
            zoneId: 0,
            disablePriceTypeQuantity: props.performancesCount != 1,
            singlePerf: props.performancesCount == 1
        }
    }

    componentWillMount() {
        if (!this.props.performanceDetail.performancePricing) {
            this.props.getPerformancePricingInfo(this.props.performance.id);
        }
        this._updateComponentOnToggleChange();
    }
    componentDidUpdate() {
        if (this.props.resetSelectedPerformance && this.state.performanceChecked && !this.props.containsreserveItems) {
            this.setState({
                performanceChecked: false
            })
        }
        if (this.state.singlePerf && !this.props.panelOpen && this.state.performanceChecked) {
            this.props.removePerformanceFromRequest(this.props.performance.id);
            this._resetQuantity();
            this.setState({
                disablePriceTypeQuantity: false,
                performanceChecked: false
            })
        }
        else if (this.state.singlePerf && this.props.panelOpen && !this.state.performanceChecked) {
            this.props.addPerformanceToRequest(this.props.performance.id);
            this.setState({
                performanceChecked: true
            })
        }
    }

    getTotalPrice(zoneId: number): number {
        if (zoneId < 1)
            return 0;
        let selectedPriceTypes = this.props.reservedPerformances.filter(req => req.performanceId == this.props.performance.id)[0].priceTypeQuantity;
        let selectedZone = this.props.performanceDetail.performancePricing.zones.filter(zone => zone.zone.id == zoneId)[0];

        var totalPrice = 0;
        selectedZone.prices.forEach(pr => {
            if (selectedPriceTypes.has(pr.priceTypeId))
                totalPrice += selectedPriceTypes.get(pr.priceTypeId) * pr.price;
        });
        return totalPrice;
    }

    _updateZone(performanceId: number, zoneId: number) {
        this.props.updateZoneToRequest(performanceId, zoneId);
        var totalPrice = this.getTotalPrice(zoneId);
        this.props.updateTotal(performanceId, totalPrice);
        this.setState({
            zoneId: zoneId
        })
    }

    _updatePerformance(event: React.ChangeEvent<HTMLInputElement>) {
        if (event.target.checked) {
            this.props.addPerformanceToRequest(this.props.performance.id);
            this.setState({
                disablePriceTypeQuantity: false,
                performanceChecked: true
            })
        } else {
            this.props.removePerformanceFromRequest(this.props.performance.id);
            this._resetQuantity();
        }
    }
    _resetQuantity():void {
        this.setState({
            disablePriceTypeQuantity: true,
            priceTypeQuantity: new Map<number, number>(),
            zoneId: 0,
            performanceChecked: false
        });
    }


    _updateComponentOnToggleChange(): void {
        if (this.props.reservedPerformances) {
            var reserveForPerf = this.props.reservedPerformances.filter(req => req.performanceId == this.props.performance.id)[0];
            if (reserveForPerf) {
                this.setState({
                    priceTypeQuantity: reserveForPerf.priceTypeQuantity,
                    zoneId: reserveForPerf.zoneId,
                    performanceChecked: true,
                    disablePriceTypeQuantity: false  
                })
            }
        }
    }
    _priceTypeQuantityUpdate(performanceNumber: number, priceTypeId: number, quantity: number):void {
        this.props.updatePriceTypeToRequest(performanceNumber, priceTypeId, quantity);
        var props = this.props;
        this.props.text.priceTypeQuantityDependencies.forEach(function (mapping) {
            if (priceTypeId == mapping.dependencyPriceType) {
                props.performanceDetail.performancePricing.priceTypeDetails.forEach(function (priceTypeDetail) {
                    if (priceTypeDetail.priceTypeId == mapping.dependentPriceType) {
                        priceTypeDetail.maxSeats = mapping.unlockedMaximumQuantity;
                    }
                });
            }
        });

        this.setState(
            {
                priceTypeQuantity: this.state.priceTypeQuantity.set(priceTypeId, quantity)
            }
        );
        if (!Array.from(this.state.priceTypeQuantity.values()).some(q => q > 0)) {
            this.setState({
                zoneId: 0
            })
        }
        var totalPrice = this.getTotalPrice(this.state.zoneId);
        this.props.updateTotal(performanceNumber, totalPrice);
    }
    render() {
        return (
            <ListPerformanceView {...this.state} {...this.props} priceTypeQuantityUpdate={this._priceTypeQuantityUpdate.bind(this)}
                updatePerformance={this._updatePerformance.bind(this)} updateZone={this._updateZone.bind(this)} />
        )
    }
}

function mapStateToProps(state: IAddOnsAppState, ownProps: IPerformanceExternalProps): StateToProps {
    var reserveFailed = false;
    var resetSelectedPerformance = false;
    if (state.addOns.failedReserve.length > 0) {
        reserveFailed = state.addOns.failedReserve.indexOf(ownProps.performance.id) == 0;
        resetSelectedPerformance = true;
    }
    var containsreserveItems = state.addOns.reserveRequests.length > 0;
    return {
        performanceDetail: ownProps.performance,
        reserveFailed: reserveFailed,
        reservedPerformances: state.addOns.reserveRequests,
        text: state.addOnsText,
        resetSelectedPerformance: resetSelectedPerformance,
        containsreserveItems: containsreserveItems,
        displayLoading: state.addOns.processing
    }
}
function mapDispatchToProps(dispatch: Dispatch): DispatchToProps {
    return {
        getPerformancePricingInfo: (id: number) => dispatch(getPerformancePricing(id) as any),
        addPerformanceToRequest: (id: number) => dispatch(addPerformanceToRequest(id) as any),
        removePerformanceFromRequest: (id: number) => dispatch(removePerformanceFromRequest(id) as any),
        updatePriceTypeToRequest: (performanceId: number, priceTypeId: number, quantity: number) => dispatch(updatePriceTypeToRequest(performanceId, priceTypeId, quantity) as any),
        updateZoneToRequest: (performanceId: number, zoneId: number) => dispatch(updateZoneToRequest(performanceId, zoneId) as any),
        updateTotal: (performanceId: number, price: number) => dispatch(updateTotal(performanceId, price) as any),
        displayLoading: (enable: boolean) => dispatch(displayLoading(enable) as any)
    }
}

export default connect<StateToProps, DispatchToProps>(mapStateToProps, mapDispatchToProps)(ListPerformanceBase);